(function () {
  var cfg = window.themeCurrencyDisplay;
  if (!cfg || !cfg.enabled) return;

  var CURRENCIES = {
    USD: { symbol: '$', prefix: true, locale: 'en-US' },
    EUR: { symbol: '€', prefix: true, locale: 'de-DE' }
  };

  function parseList(str) {
    return String(str || '')
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);
  }

  var COUNTRY_CURRENCY = { US: 'USD' };
  [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
    'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
  ].forEach(function (code) { COUNTRY_CURRENCY[code] = 'EUR'; });

  function resolveCurrency() {
    var market = String(cfg.market || '').toLowerCase();
    if (market) {
      if (parseList(cfg.usdMarkets).indexOf(market) !== -1) return 'USD';
      if (parseList(cfg.eurMarkets).indexOf(market) !== -1) return 'EUR';
    }
    return COUNTRY_CURRENCY[String(cfg.country || '').toUpperCase()] || null;
  }

  var currency = resolveCurrency();
  if (!currency) return;

  var rate = parseFloat(String(cfg.rates[currency]).replace(',', '.'));
  if (!rate || rate <= 0) return;

  function round(value) {
    switch (cfg.rounding) {
      case '1': return Math.round(value);
      case '5': return Math.round(value / 5) * 5;
      case '9': return Math.floor(value) + 0.9;
      default: return value;
    }
  }

  function convert(cents, qty) {
    qty = qty > 0 ? qty : 1;
    return round(cents / qty / 100 / rate) * qty;
  }

  function sumItems(str) {
    var total = 0;
    var pairs = String(str).split(',');
    for (var i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split(':');
      var cents = parseInt(parts[0], 10);
      var qty = parseInt(parts[1], 10);
      if (!isNaN(cents)) total += convert(cents, qty);
    }
    return total;
  }

  function format(cents, qty) {
    return formatValue(convert(cents, qty));
  }

  function formatValue(value) {
    var meta = CURRENCIES[currency];
    var decimals = cfg.rounding === 'none' || cfg.rounding === '9' ? 2 : 0;
    var num = new Intl.NumberFormat(meta.locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);
    return meta.prefix ? meta.symbol + num : num + ' ' + meta.symbol;
  }

  function convertBlock(block) {
    if (block.dataset.moneyConverted === currency) return;

    var cents = parseInt(block.dataset.moneyCents, 10);
    var min = parseInt(block.dataset.moneyMin, 10);
    var max = parseInt(block.dataset.moneyMax, 10);
    var qty = parseInt(block.dataset.moneyQty, 10);

    var regular = block.querySelectorAll('[data-money-target="regular"]');
    for (var i = 0; i < regular.length; i++) {
      if (!isNaN(min) && !isNaN(max) && min !== max) {
        regular[i].textContent = format(min) + ' – ' + format(max);
      } else if (block.dataset.moneyItems) {
        regular[i].textContent = formatValue(sumItems(block.dataset.moneyItems));
      } else if (!isNaN(cents)) {
        regular[i].textContent = format(cents, qty);
      }
    }

    var compare = block.querySelectorAll('[data-money-target="compare"]');
    var compareCents = parseInt(block.dataset.moneyCompare, 10);
    for (var j = 0; j < compare.length; j++) {
      if (!isNaN(compareCents) && compareCents > 0) {
        compare[j].textContent = format(compareCents);
      }
    }

    if (block.dataset.moneyOriginal) {
      var original = block.querySelector('.currency-original');
      if (!original) {
        original = document.createElement('span');
        original.className = 'currency-original';
        block.appendChild(original);
      }
      original.textContent = block.dataset.moneyOriginal;
    }

    block.dataset.moneyConverted = currency;
  }

  function convertAll(root) {
    var blocks = (root || document).querySelectorAll('[data-money]');
    for (var i = 0; i < blocks.length; i++) convertBlock(blocks[i]);
  }

  function buildNotice() {
    if (!cfg.noticeEnabled || !cfg.noticeText) return null;
    var el = document.createElement('p');
    el.className = 'currency-notice';
    el.textContent = cfg.noticeText;
    return el;
  }

  function placeNotices() {
    if (!cfg.noticeEnabled) return;
    var hosts = document.querySelectorAll(
      '.product__info-container .price, .totals'
    );
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      if (host.parentNode.querySelector('.currency-notice')) continue;
      var notice = buildNotice();
      if (notice) host.parentNode.insertBefore(notice, host.nextSibling);
    }
  }

  function refresh() {
    convertAll();
    placeNotices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = null;
      refresh();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('variant:change', refresh);
  document.addEventListener('cart:updated', refresh);
})();
